class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.numberInputs = Array.from(this.querySelectorAll('input[type="number"]'));
    this.sliders = Array.from(this.querySelectorAll('.price-range-slider__input'));
    this.fillEl = this.querySelector('.price-range-slider__fill');
    this.minDisplay = this.querySelector('.price-range-values__min');
    this.maxDisplay = this.querySelector('.price-range-values__max');
    this._syncing = false;
    this.SCALE = 1000; // escala interna del slider (0-1000)

    // Listeners en los inputs numéricos (fallback sin slider)
    this.numberInputs.forEach((el) =>
      el.addEventListener('change', this.onRangeChange.bind(this))
    );

    // Listeners en los sliders
    if (this.sliders.length === 2) {
      // Leer precio máximo real del atributo max del slider
      this.priceMax = parseFloat(this.sliders[0].max) || 100;

      // Leer precio inicial (puede venir del value del slider)
      const initPriceMin = parseFloat(this.sliders[0].value) || 0;
      const initPriceMax = parseFloat(this.sliders[1].value) || this.priceMax;

      // Convertir sliders a escala interna 0-SCALE
      this.sliders[0].min = 0;
      this.sliders[0].max = this.SCALE;
      this.sliders[1].min = 0;
      this.sliders[1].max = this.SCALE;
      this.sliders[0].value = this.priceToSlider(initPriceMin);
      this.sliders[1].value = this.priceToSlider(initPriceMax);

      this.sliders.forEach((el) => {
        el.addEventListener('input', this.onSliderInput.bind(this));
        el.addEventListener('change', this.onSliderCommit.bind(this));
        el.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
        el.addEventListener('touchmove', (e) => e.stopPropagation(), { passive: true });
      });

      // En iOS el slider de encima siempre captura el toque ignorando pointer-events.
      // Ponemos encima el que esté más cerca del punto tocado.
      const onPointerDown = (e) => {
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const rect = this.sliders[0].getBoundingClientRect();
        const pct = (clientX - rect.left) / rect.width;
        const minPct = parseFloat(this.sliders[0].value) / this.SCALE;
        const maxPct = parseFloat(this.sliders[1].value) / this.SCALE;
        const distMin = Math.abs(pct - minPct);
        const distMax = Math.abs(pct - maxPct);
        if (distMin <= distMax) {
          this.sliders[0].style.zIndex = 3;
          this.sliders[1].style.zIndex = 2;
        } else {
          this.sliders[0].style.zIndex = 2;
          this.sliders[1].style.zIndex = 3;
        }
      };
      this.sliders[0].addEventListener('touchstart', onPointerDown, { passive: true });
      this.sliders[1].addEventListener('touchstart', onPointerDown, { passive: true });
      this.sliders[0].addEventListener('mousedown', onPointerDown);
      this.sliders[1].addEventListener('mousedown', onPointerDown);

      this.updateFill();
      this.updateZIndex();
      if (this.minDisplay) this.minDisplay.textContent = Math.floor(initPriceMin);
      if (this.maxDisplay) this.maxDisplay.textContent = Math.floor(initPriceMax);
    }

    this.setMinAndMaxValues();
  }

  // Convierte precio real → posición interna (0-SCALE) con escala logarítmica
  priceToSlider(price) {
    if (this.priceMax <= 0) return 0;
    const pct = Math.log(price + 1) / Math.log(this.priceMax + 1);
    return Math.round(pct * this.SCALE);
  }

  // Convierte posición interna (0-SCALE) → precio real con escala logarítmica
  sliderToPrice(sliderVal) {
    const pct = sliderVal / this.SCALE;
    return Math.round(Math.pow(this.priceMax + 1, pct) - 1);
  }

  onSliderInput() {
    let minSlider = parseFloat(this.sliders[0].value);
    let maxSlider = parseFloat(this.sliders[1].value);

    // Evitar que los thumbs se crucen
    if (minSlider > maxSlider) {
      this.sliders[0].value = maxSlider;
      minSlider = maxSlider;
    }

    const minPrice = this.sliderToPrice(minSlider);
    const maxPrice = this.sliderToPrice(maxSlider);

    if (this.minDisplay) this.minDisplay.textContent = minPrice;
    if (this.maxDisplay) this.maxDisplay.textContent = maxPrice;
    this.updateFill();
    this.updateZIndex();
  }

  onSliderCommit() {
    if (this._syncing) return;
    this._syncing = true;

    const minPrice = this.sliderToPrice(parseFloat(this.sliders[0].value));
    const maxPrice = this.sliderToPrice(parseFloat(this.sliders[1].value));

    if (this.numberInputs[0]) {
      this.numberInputs[0].value = minPrice > 0 ? minPrice : '';
    }
    if (this.numberInputs[1]) {
      this.numberInputs[1].value = maxPrice < this.priceMax ? maxPrice : '';
    }

    // Disparar input event para que FacetFiltersForm actualice los resultados
    if (this.numberInputs[0]) {
      this.numberInputs[0].dispatchEvent(new Event('input', { bubbles: true }));
    }

    this._syncing = false;
  }

  updateFill() {
    if (!this.fillEl || this.sliders.length < 2) return;
    const minVal = parseFloat(this.sliders[0].value) || 0;
    const maxVal = isNaN(parseFloat(this.sliders[1].value)) ? this.SCALE : parseFloat(this.sliders[1].value);
    const leftPct = (minVal / this.SCALE) * 100;
    const rightPct = (maxVal / this.SCALE) * 100;
    this.fillEl.style.left = leftPct + '%';
    this.fillEl.style.width = (rightPct - leftPct) + '%';
  }

  updateZIndex() {
    if (this.sliders.length < 2) return;
    const minVal = parseFloat(this.sliders[0].value);
    if (minVal >= this.SCALE) {
      this.sliders[0].style.zIndex = 2;
      this.sliders[1].style.zIndex = 1;
    } else {
      this.sliders[0].style.zIndex = 1;
      this.sliders[1].style.zIndex = 2;
    }
  }

  onRangeChange(event) {
    if (this._syncing) return;
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();

    // Sincronizar slider con el número cambiado manualmente
    if (this.sliders.length === 2) {
      const minPrice = this.numberInputs[0] ? (parseFloat(this.numberInputs[0].value) || 0) : 0;
      const maxPrice = this.numberInputs[1]
        ? (parseFloat(this.numberInputs[1].value) || this.priceMax)
        : this.priceMax;
      this.sliders[0].value = this.priceToSlider(minPrice);
      this.sliders[1].value = this.priceToSlider(maxPrice);
      if (this.minDisplay) this.minDisplay.textContent = minPrice;
      if (this.maxDisplay) this.maxDisplay.textContent = maxPrice;
      this.updateFill();
    }
  }

  setMinAndMaxValues() {
    const minInput = this.numberInputs[0];
    const maxInput = this.numberInputs[1];
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
